import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const detail = error.response?.data?.detail;
    if (error.response?.status === 403 && typeof detail === "string" && detail.startsWith("Not available in")) {
      try {
        const saved = JSON.parse(localStorage.getItem("salon_mode") || "null");
        const serverMode = (detail.match(/Not available in (\w+) Mode/) || [])[1]?.toLowerCase();
        if (saved?.mode && serverMode && saved.mode !== serverMode) {
          localStorage.removeItem("salon_mode");
          window.location.reload();
          return new Promise(() => {});
        }
      } catch (e) {
        console.warn("Stale mode-token check failed:", e);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
